import cloneDeep from 'lodash/cloneDeep';
import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {truncateMiddle} from 'common/util/string';

import {MPCustomEvent} from '../custom-event-modal/models/events';
import template from './index.jade';
import css from './index.styl?inline';

export class CustomEventTooltip extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'custom-event-id': `number`,
    };
  }

  get config() {
    return {
      template,
      useShadowDom: true,
      css,
      defaultState: {
        customEvents: [],
      },
      helpers: {
        truncateMiddle,
        createTooltip: (emptyVnode, vnode) => {
          vnode.elm.parentEl = this.parentNode;
        },
        getCustomEventTooltipParts: () => {
          const serializedCustomEvent = this.getCustomEventById(this.state.customEventID);
          // handle scenario where custom event has been deleted
          if (!serializedCustomEvent || !serializedCustomEvent.alternatives) {
            return [{label: `Deleted event`}];
          }

          serializedCustomEvent.alternatives.forEach((alt) => {
            if (alt.event.startsWith(MPCustomEvent.CUSTOM_EVENT_PREFIX)) {
              const id = Number(alt.event.split(`:`)[1]);
              const customEvent = this.getCustomEventById(id);
              alt.event = customEvent ? customEvent.name : `Custom Event`;
            }
          });

          return MPCustomEvent.fromSerializedCustomEvent(serializedCustomEvent).getLabelParts();
        },
      },
    };
  }

  getCustomEventById(id) {
    const {customEvents} = this.state;
    // Return a clone to ensure we don't modify the original custom event, since it was passed in by reference
    // (via customEvents prop).
    return cloneDeep(customEvents.find((customEvent) => customEvent.id === id));
  }

  set customEvents(customEvents) {
    this.update({customEvents});
  }

  attributeChangedCallback(attr) {
    super.attributeChangedCallback(...arguments);
    if (attr === `custom-event-id`) {
      this.update({customEventID: this.attr(attr)});
    }
  }
}

export const CustomEventTooltipEl = defineAndMakeJsxFactory(`mp-custom-event-tooltip`, CustomEventTooltip);
